import React, { useState } from 'react';

import RenderIf from 'components/RenderIf';
import CustomProgress from 'modules/auth/components/CustomProgress';
import { Helmet } from 'react-helmet-async';
import {useTranslation} from "react-i18next";

import Table from '../home/components/Table';
import Barcode from '../home/modals/Barcode';

import './MyTickets.css';

export default function MyTickets() {
  const [isLoading, setIsLoading] = useState(true);
  const [showBarcode, setShowBarcode] = useState(false);
  const [ticketInformation, setTicketInformation] = useState({});

  const {t} = useTranslation();

  return (
    <React.Fragment>
      <Helmet>
        <title>{t("MY_TICKETS")} | 1x2</title>
        <meta name="description" content={`${t("MY_TICKETS")} | 1x2`} />
      </Helmet>
      <div className="my-tickets">
        <div className="container my-tickets__container">
          <div className="my-tickets__title">
            <span>{t("MY_TICKETS")}</span>
          </div>

          <div className="wrapper-table">
            <Table
              setIsLoading={setIsLoading}
              isLoading={isLoading}
              setShowBarcode={setShowBarcode}
              setTicketInformation={setTicketInformation}
            />
          </div>
        </div>
      </div>
      <RenderIf condition={isLoading}>
        <CustomProgress />
      </RenderIf>
      <RenderIf condition={showBarcode}>
        <Barcode
          show={showBarcode}
          onHide={setShowBarcode}
          ticketInformation={ticketInformation}
          url="tickets"
        />
      </RenderIf>
    </React.Fragment>
  );
}
